export default __webpack_public_path__ + "static/media/curvePath.1d596010.svg";